import { format } from 'date-fns'
import React from 'react'
import PropTypes from 'prop-types'
import queryString from 'query-string'

import { DeletedLabel, DepartureContainer } from '../containers/Passages.styles'
import { getDepartureTime } from '../containers/PassagesUtils'
import { getDepartureTimeColor } from '../helpers/helpers'
import NoRealtimeIrtis from './NoRealtime.irtis'
import RealtimeIrtis from './Realtime.irtis'
import DeletedIrtis from './Deleted.irtis'

export function departureOrArrivalTime(showEindHaltes, line, currentTime) {
  if (showEindHaltes && line.eindHalte) {
    return {
      time: getDepartureTime(
        line.aankomstTheoretischTijdstip,
        line.aankomstRealtimeTijdstip,
        currentTime,
      ),
      theoreticalTime: format(line.aankomstTheoretischTijdstip, 'HH:mm'),
    }
  } else {
    return {
      time: getDepartureTime(
        line.vertrekTheoretischeTijdstip,
        line.vertrekRealtimeTijdstip,
        currentTime,
      ),
      theoreticalTime: format(line.vertrekTheoretischeTijdstip, 'HH:mm'),
    }
  }
}

const Departure = ({
  line = {},
  error,
  currentTime,
  queryParam,
  lightMode,
  noRealtimeCopy,
  isPreSubway,
}) => {
  const realtime = line.predictionStatussen?.includes('REALTIME') && !error
  const isDeleted = line.predictionStatussen?.includes('DELETED')
  const isShortened = line.predictionStatussen?.includes('SHORTENED')
  const departureTimeColor = getDepartureTimeColor(queryParam, isDeleted)

  const { includeEindHaltes } = queryString.parse(location.search)
  const showEindHaltes = includeEindHaltes === 'true'

  const { time, theoreticalTime } = departureOrArrivalTime(
    showEindHaltes,
    line,
    currentTime,
  )

  return (
    <DepartureContainer
      realtime={realtime}
      data-testid="irtis-departure-container"
      isDeleted={isDeleted}
    >
      {isDeleted && (
        <>
          <div>
            <DeletedLabel isDeleted={isDeleted} isPreSubway={isPreSubway}>
              Rijdt niet
            </DeletedLabel>
          </div>
          <DeletedIrtis
            theoreticalTime={theoreticalTime}
            isPreSubway={isPreSubway}
            lightMode={lightMode}
          />
        </>
      )}
      {isShortened && (
        <div>
          <DeletedLabel isPreSubway={isPreSubway}>
            rijdt tot {line.eindHalteBijSchrapping}
          </DeletedLabel>
        </div>
      )}

      {realtime && !isDeleted && (
        <RealtimeIrtis
          time={time}
          line={line}
          lightMode={lightMode}
          currentTime={currentTime}
          departureTimeColor={departureTimeColor}
          error={error}
          showEindHaltes={showEindHaltes}
          theoreticalTime={theoreticalTime}
          realtime={realtime}
          isPreSubway={isPreSubway}
        />
      )}
      {!realtime && !isDeleted && (
        <NoRealtimeIrtis
          theoreticalTime={theoreticalTime}
          departureTimeColor={departureTimeColor}
          noRealtimeCopy={noRealtimeCopy}
          isPreSubway={isPreSubway}
          lightMode={lightMode}
        />
      )}
    </DepartureContainer>
  )
}

Departure.propTypes = {
  line: PropTypes.shape({
    predictionStatussen: PropTypes.array,
    vertrekTheoretischeTijdstip: PropTypes.number,
    vertrekRealtimeTijdstip: PropTypes.number,
    aankomstTheoretischTijdstip: PropTypes.number,
    aankomstRealtimeTijdstip: PropTypes.number,
  }),
  error: PropTypes.bool,
  currentTime: PropTypes.number,
  lightMode: PropTypes.bool,
  queryParam: PropTypes.shape({
    inverse: PropTypes.string,
  }),
  noRealtimeCopy: PropTypes.string.isRequired,
  isPreSubway: PropTypes.bool.isRequired,
}

export default Departure
